module.exports = __webpack_public_path__ + "6beda567530581d6cd7721f2d252a4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_MyCanadaPlan_fr.jpg
// module id = 1566
// module chunks = 0